import { useState } from "react";
import { C, font, WHATSAPP_NUMBER } from "../tokens";

// Webhook do CRM (t0 no build) — recebe os dados do formulário do FAB.
const WEBHOOK_URL =
  "https://crm.imobmeet.com.br/webhook/formulario/2c52df458f8be452e96ca5a3480434786cf73ed7";

// Envio silencioso para o CRM (n0 no build).
function postLead({ nome, empresa, telefone }) {
  try {
    const o = new FormData();
    o.append("Nome", nome);
    o.append("Empresa", empresa);
    o.append("Telefone", telefone);
    o.append("Origem", "Botão WhatsApp");
    new URLSearchParams(window.location.search).forEach((a, l) => o.append(l, a));
    o.append("page_url", window.location.href);
    o.append("page_title", document.title);
    fetch(WEBHOOK_URL, { method: "POST", body: o, keepalive: true }).catch(() => {});
  } catch {}
}

// Estilo de input (oa no build).
const inputStyle = {
  width: "100%",
  padding: "11px 13px",
  borderRadius: 10,
  border: `1.5px solid ${C.border}`,
  fontFamily: font,
  fontSize: 14.5,
  outline: "none",
  background: C.surface,
  color: C.text,
  boxSizing: "border-box",
};

// Ícone do WhatsApp (ia no build).
const WaIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.47 14.38c-.3-.15-1.74-.86-2-.96-.27-.1-.46-.15-.65.15-.2.3-.75.95-.92 1.14-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.65-1.57-.9-2.15-.24-.56-.48-.48-.65-.49-.17-.01-.37-.01-.56-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.88 1.21 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.74-.71 1.98-1.4.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34zM12.05 21.5h-.01a9.5 9.5 0 0 1-4.84-1.33l-.35-.2-3.6.94.96-3.5-.23-.36A9.46 9.46 0 0 1 2.55 12 9.5 9.5 0 0 1 12.06 2.5a9.45 9.45 0 0 1 6.72 2.79A9.45 9.45 0 0 1 21.55 12a9.5 9.5 0 0 1-9.5 9.5zM20.2 3.85A11.4 11.4 0 0 0 12.05.5 11.5 11.5 0 0 0 .55 12c0 2.03.53 4 1.54 5.75L.5 23.5l5.9-1.55a11.5 11.5 0 0 0 5.65 1.44h.01A11.5 11.5 0 0 0 23.55 12c0-3.07-1.2-5.96-3.36-8.15z" />
  </svg>
);

// ─── FAB do WhatsApp com formulário (r0) ───────────────────
export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ nome: "", empresa: "", telefone: "" });

  const change = (key) => (ev) =>
    setData((g) => ({ ...g, [key]: ev.target.value }));

  const submit = (ev) => {
    ev.preventDefault();
    postLead(data);
    const msg = `Olá! Vim pelo site do IMOBMEET e gostaria de saber mais.

Nome: ${data.nome}
Empresa: ${data.empresa}
Telefone: ${data.telefone}`;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setOpen(false);
    setData({ nome: "", empresa: "", telefone: "" });
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 24,
        bottom: 24,
        zIndex: 201,
        fontFamily: font,
      }}
    >
      {open && (
        <div
          role="dialog"
          aria-label="Falar no WhatsApp"
          style={{
            position: "absolute",
            right: 0,
            bottom: 74,
            width: "min(322px, calc(100vw - 40px))",
            background: C.surface,
            border: `1px solid ${C.border}`,
            borderRadius: 18,
            boxShadow: "0 24px 60px rgba(10,15,30,0.22)",
            padding: 18,
            animation: "slide-up-fade 0.3s cubic-bezier(.16,1,.3,1) both",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 11, marginBottom: 14 }}>
            <span
              style={{
                width: 42,
                height: 42,
                borderRadius: 12,
                flexShrink: 0,
                background: "rgba(37,211,102,0.12)",
                color: "#25D366",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WaIcon size={24} />
            </span>
            <div style={{ lineHeight: 1.3 }}>
              <div
                style={{
                  fontFamily: font,
                  fontWeight: 800,
                  fontSize: 15.5,
                  color: C.text,
                }}
              >
                Falar no WhatsApp
              </div>
              <div style={{ fontFamily: font, fontSize: 12.5, color: C.muted }}>
                Preencha para continuar
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              aria-label="Fechar"
              style={{
                marginLeft: "auto",
                width: 28,
                height: 28,
                borderRadius: 8,
                cursor: "pointer",
                background: C.bgAlt,
                border: `1px solid ${C.border}`,
                color: C.muted,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <input
              required
              value={data.nome}
              onChange={change("nome")}
              placeholder="Nome"
              onFocus={(u) => (u.target.style.borderColor = C.accent)}
              onBlur={(u) => (u.target.style.borderColor = C.border)}
              style={inputStyle}
            />
            <input
              required
              value={data.empresa}
              onChange={change("empresa")}
              placeholder="Empresa"
              onFocus={(u) => (u.target.style.borderColor = C.accent)}
              onBlur={(u) => (u.target.style.borderColor = C.border)}
              style={inputStyle}
            />
            <input
              required
              type="tel"
              inputMode="tel"
              value={data.telefone}
              onChange={change("telefone")}
              placeholder="Telefone / WhatsApp"
              onFocus={(u) => (u.target.style.borderColor = C.accent)}
              onBlur={(u) => (u.target.style.borderColor = C.border)}
              style={inputStyle}
            />
            <button
              type="submit"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 9,
                marginTop: 2,
                padding: "13px 16px",
                borderRadius: 11,
                cursor: "pointer",
                background: "#25D366",
                border: "none",
                color: "#fff",
                fontFamily: font,
                fontSize: 15,
                fontWeight: 800,
                boxShadow: "0 10px 24px rgba(37,211,102,0.34)",
              }}
            >
              <WaIcon size={19} /> Continuar no WhatsApp
            </button>
          </form>
        </div>
      )}
      <button
        className="wa-buzz"
        onClick={() => setOpen((u) => !u)}
        aria-label="Falar no WhatsApp"
        title="Falar no WhatsApp"
        style={{
          width: 60,
          height: 60,
          borderRadius: 16,
          padding: 0,
          background: "#25D366",
          color: "white",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 14px 30px rgba(37,211,102,0.40)",
          transition: "box-shadow 0.2s",
        }}
        onMouseEnter={(u) => {
          u.currentTarget.style.boxShadow = "0 18px 40px rgba(37,211,102,0.55)";
        }}
        onMouseLeave={(u) => {
          u.currentTarget.style.boxShadow = "0 14px 30px rgba(37,211,102,0.40)";
        }}
      >
        <WaIcon size={32} />
      </button>
    </div>
  );
}
